(function () {
    'use strict';

    angular
        .module('app.service')
        .factory('auditService', auditService);

    /* @ngInject */
    function auditService($http, $q, exception, logger, coreService, moment, config, $odataresource, $odata) {
        var service = {          
            getODataResource: getODataResource,
            getEventTypeODataResource: getEventTypeODataResource,
            getTableConfig: getTableConfig,
            getDetailTableConfig: getDetailTableConfig,
            getAuditLogs: getAuditLogs,
            getModalOptions: getModalOptions,
            getEventTypes: getEventTypes,
            getSchemaTypes: getSchemaTypes,
            getAuditLogsBySettings: getAuditLogsBySettings
        };

        activate();

        return service;

        function activate() {
        }

        function getTableConfig() {
            var tableConfig = {
                columns: [
                    {
                        id: 'AuditEventTypeId',
                        displayName: 'Event Type',
                        ODataKey: 'AuditEventTypeId',
                        type: 'dropDown',
                        DropDown: { parent: 'AuditEventType', key: 'EventName' },
                        options: []
                    },      
                    {
                        id: 'EventDate',
                        displayName: 'Event Date',
                        ODataKey: 'EventDate',
                        type: 'datetime'
                    },
                    {
                        id: 'SchemaName',
                        displayName: 'Application',
                        ODataKey: 'SchemaName',
                        type: 'match'
                    },
                    {
                        id: 'TableName',
                        displayName: 'Table Name',
                        ODataKey: 'TableName',
                        type: 'match'
                    },
                    {
                        id: 'FullName',
                        displayName: 'User',
                        ODataKey: 'User/FullName',
                        type: 'subItem'                        
                    }
                ],
                actions: []
            };
            return tableConfig;
        }

        function getDetailTableConfig() {
            var tableConfig = {
                columns: [
                    {
                        id: 'AuditLogId',
                        displayName: 'Audit Log Id',
                        ODataKey: 'AuditLogId',
                        type: 'match'                      
                    },
                    {
                        id: 'PropertyName',
                        displayName: 'Property Name',
                        ODataKey: 'PropertyName',
                        type: 'match'
                    },
                    {
                        id: 'OldValue',
                        displayName: 'Old Value',
                        ODataKey: 'OldValue',
                        type: 'match'
                    },
                    {
                        id: 'NewValue',
                        displayName: 'New Value',
                        ODataKey: 'NewValue',
                        type: 'match'
                    }
                ],
                actions: []
            };
            return tableConfig;
        }

        function getODataResource() {
            return $odataresource(config.apiUrl + 'odata/AuditLogs',
                {},
                {},
                {
                    odatakey: 'AuditLogId',
                    isodatav4: true
                });
        }

        function getEventTypeODataResource() {
            return $odataresource(config.apiUrl + 'odata/AuditEventTypes',
                {},
                {},
                {
                    odatakey: 'AuditEventTypeId',
                    isodatav4: true
                });
        }

        function getAuditLogs(tableState) {
            var query = service.getODataResource().odata();

            if (!!tableState) {
                coreService.processODataFilters(query, tableState.search.predicateObject, getTableConfig().columns);
                coreService.processODataPage(query, tableState.pagination);
            } else {
                tableState = { sort: {} };
            }
            tableState.sort = tableState.sort.predicate ? tableState.sort : {
                predicate: 'EventDate', reverse: true
            };
            coreService.processODataSort(query, tableState.sort);

            return query
                .expand('AuditEventType')
                .expand('AuditLogDetails')
                .expand('User')
                .withInlineCount()
                .take(10)
                .query()
                .$promise;
        }

        function getAuditLogsBySettings(tableState) {
            var orderBy = tableState.sort.predicate;

            if (orderBy === undefined) {
                orderBy = 'EventDate';
            } else if (orderBy === 'User/FullName') {
                orderBy = 'FullName';
            } else if (orderBy === 'AuditEventTypeId') {
                orderBy = 'EventName';
            }

            var sortDirection = tableState.sort.reverse;
            if (sortDirection === undefined) {
                sortDirection = false;
            }

            var url = 'auditLogs/GetAuditLogs/orderBy/' + orderBy +
                '/sortDirection/' + sortDirection +
                '/skip/' + tableState.pagination.start +
                '/take/' + tableState.pagination.number;

            var deffered = $q.defer();
            return coreService.httpAccountsGetAbortCapable(url, deffered);
        }

        function getEventTypes() {
            var query = service.getEventTypeODataResource().odata();

            return query
                .select('AuditEventTypeId', 'EventName')
                .withInlineCount()
                .query()
                .$promise;
        }   

        function getSchemaTypes() {
            return coreService.httpAccountsGet('auditLogs/schemas');
        }

        function getModalOptions() {
            return {
                animation: true,
                templateUrl: 'app/audit/dashboard/modal/audit.modal.html',
                controllerAs: 'vm',
                size: 'lg'
            };
        }
    }
})();
